/**
 * Runs `run(key)` at most once per `intervalMs` for each key: the first call
 * runs at once, and calls inside the window collapse into one run at its end.
 */
export const createKeyedThrottle = (
  run: (key: string) => void,
  intervalMs: number,
) => {
  const windows = new Map<
    string,
    { pending: boolean; timeout: ReturnType<typeof setTimeout> }
  >();

  const openWindow = (key: string) => {
    const slot = {
      pending: false,
      timeout: setTimeout(() => {
        windows.delete(key);
        if (!slot.pending) return;
        run(key);
        openWindow(key);
      }, intervalMs),
    };
    windows.set(key, slot);
  };

  return {
    call: (key: string) => {
      const slot = windows.get(key);
      if (slot) {
        slot.pending = true;
        return;
      }
      run(key);
      openWindow(key);
    },
    cancel: () => {
      for (const { timeout } of windows.values()) clearTimeout(timeout);
      windows.clear();
    },
  };
};
